export default __webpack_public_path__ + "static/ifp-step-3-30ea357c6a01c997a4edc5399a533dba.svg";